export const getCanonicalHref = () => {
  const protocol = 'https://';
  const host = window.location.host.replace(/^www\./, '');
  let pathname = window.location.pathname.replace(/(.*?)(\/?)$/, '$1');
  pathname = pathname === '/home' ? '' : pathname;
  const { search } = window.location;

  return protocol + host + pathname + search;
};
